<template>
  <div class="bg-white rounded-2xl shadow-xl border border-gray-100 py-5 px-6">
    <p class="text-xs font-semibold uppercase tracking-widest text-gray-400">{{ t("store_label") }}</p>

    <SearchSelector
      v-if="hasMultipleStores"
      class="mt-1"
      name="store"
      :options="storeOptions"
      :modelValue="selectedStoreId"
      @update:modelValue="$emit('store-change', $event)"
    />
    <p v-else class="text-2xl font-extrabold tracking-tight mt-1">{{ storeName }}</p>

    <p class="text-sm text-gray-500 mt-0.5">{{ t("seller_count", sellerCount) }}</p>

    <div class="flex gap-7 mt-4 pt-4 border-t border-gray-100">
      <div>
        <p class="text-xs text-gray-500">{{ t(`challenge.counting.${countingMethod}.column`) }}</p>
        <p class="text-2xl font-extrabold">{{ totalSales }}</p>
      </div>
      <template v-if="isGrossSales">
        <div>
          <p class="text-xs text-gray-500">{{ t("challenge.leads_label") }}</p>
          <p class="text-2xl font-extrabold">{{ cappedLeads }}</p>
        </div>
        <div v-if="totalSales > 0">
          <p class="text-xs text-gray-500">{{ t("compliance_label") }}</p>
          <p class="text-2xl font-extrabold" :class="isCompliant ? 'text-green-700' : 'text-red-600'">
            {{ complianceRate }} %
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { SearchSelector } from "@estaly/ui";
import { COMPLIANCE_THRESHOLD, complianceRate, isGrossSalesCounting } from "@/utils/challengeTiers";

export default {
  components: { SearchSelector },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    storeName: {
      type: String,
      required: true,
    },
    totalSales: {
      type: Number,
      required: true,
    },
    sellerCount: {
      type: Number,
      required: true,
    },
    leadsCount: {
      type: Number,
      default: 0,
    },
    countingMethod: {
      type: String,
      default: "plan_sales",
    },
    storeOptions: {
      type: Array,
      default: () => [],
    },
    selectedStoreId: {
      default: null,
    },
    hasMultipleStores: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["store-change"],

  computed: {
    isGrossSales() {
      return isGrossSalesCounting(this.countingMethod);
    },

    cappedLeads() {
      return Math.min(this.leadsCount, this.totalSales);
    },

    complianceRate() {
      return complianceRate(this.leadsCount, this.totalSales);
    },

    isCompliant() {
      return this.complianceRate >= COMPLIANCE_THRESHOLD;
    },
  },
};
</script>

<i18n src="./TieredChallengeStoreCard.i18n.json"></i18n>
